<template>
  <Datepicker
    lang="es"
    :style="customStyles"
    inputClass="filter-datepicker"
    :placeholder="label"
    range
    showClearButton
    :disabled-end-date="{ from: new Date(), to: null }"
    :value="value"
    @input="onChange"
    @reset="$emit('reset')"
  />
</template>

<script>
// Component
import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import VueDatepickerUi from 'vue-datepicker-ui'

// Utils
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    label: String
    // pick: {
    //   type: Array,
    //   default: () => []
    // }
  },
  components: {
    Datepicker: VueDatepickerUi
  },
  data () {
    return {
      value: []
    }
  },
  computed: {
    customStyles () {
      return {
        '--v-calendar-input-bg-color': '#e9ecef',
        '--v-calendar-triangle-color': 'white',
        ' --v-calendar-datepicker-icon-color': '#e9ecef',
        '--v-calendar-datepicker-icon-color': '#6c757d',
        '--v-calendar-active-bg-color': '#6c757d',
        '--v-calendar-day-hover-bg-color': '#e9ecef',
        '--v-calendar-range-bg-color': '#e9ecef',
        '--v-calendar-day-width': '36px',
        '--v-calendar-day-height': '36px',
        '--v-calendar-range-radius': 'none',
        '--v-calendar-input-border': 'none',
        '--v-calendar-shadow': '0 5px 10px 0 rgba(0, 0, 0, 0.2)',
        '--v-calendar-top-shadow': '3px -14px 30px 0px rgba(0, 0, 0, 0.2)'
      }
    }
  },
  methods: {
    onChange (event) {
      if (event.length) {
        let [ from, to ] = event
        from = from ? moment(from).set('hour', 0).set('minute', 0).set('second', 0).toISOString() : null
        to = to ? moment(to).set('hour', 23).set('minute', 59).set('second', 59).toISOString() : null
        const dates = [
          { value: from },
          { value: to }
        ]
        this.$emit('change', dates)
      }
    }
  },
  created () {
    // NOTA. pick no aplica ya que no es útil este filtro en modo construcción
    // ya que no es dinamico

    // if (this.pick.length) {
    //   this.value = this.pick.map(el => {
    //     if (el?.value) {
    //       return moment(el.value).toDate()
    //     }
    //     return null
    //   })
    // } else {
    //   const weekAgo = moment().day(-7).toDate()
    //   const now = moment().toDate()
    //   this.value.push(weekAgo)
    //   this.value.push(now)
    // }
  }
}
</script>

<style lang="sass">
.v-calendar
  .filter-datepicker
    height: 37px !important
    border-radius: 8px !important
  button span.number
    border-radius: 50%
</style>
